





































import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { AccountTypeEnum, AccountStateEnum } from '@/api/types';
import { list_accounts } from '@/api/account';

type HeaderType = {
  text: string;
  value: string;
};

@Component({
  name: 'AccountListResult',
})
export default class extends Vue {
  @Prop({ required: true }) accounts!: list_accounts.Account[];
  private headers: HeaderType[] = [];
  private loading = false;
  private filterText = '';

  mounted() {
    this.loadHeaders();
  }

  private loadHeaders() {
    const id: HeaderType = {
      text: this.$t('Account') as string,
      value: 'id',
    };
    const accountType: HeaderType = {
      text: this.$t('Account type') as string,
      value: 'accountType',
    };
    // const agentName: HeaderType = {
    //   text: this.$t('Agent name') as string,
    //   value: 'agentName',
    // };
    const accountState: HeaderType = {
      text: this.$t('Account state') as string,
      value: 'accountState',
    };
    const headers: HeaderType[] = [id, accountType, accountState];
    this.headers = headers;
  }

  private getAccountTypeText(type: AccountTypeEnum) {
    return this.$t(`AccountTypeEnum.${type}`);
  }

  private getAccountStateText(state: AccountStateEnum) {
    return (state as AccountStateEnum) === AccountStateEnum.ACTIVE
      ? this.$t('Active')
      : this.$t('Inactive');
  }
}
